import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=e5586ab4&scoped=true&"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDashboard.vue?vue&type=style&index=0&id=e5586ab4&scoped=true&lang=css&"
import style1 from "./ReportsDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5586ab4",
  null
  
)

export default component.exports